export const AWS_CONFIG = {
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: 'US-EAST-1',

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: 'us-east-1_33PsHtEL9',

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: /*'36iaro6ddsrgup9p2rq1lm80tp' ||*/ '27vpjtf9dhhhakrg4l53flun6v',

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
    // authenticationFlowType: 'USER_PASSWORD_AUTH',
    // OPTIONAL - Hosted UI configuration
    oauth: {
      domain: 'login.stayurbain.com',
      scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      redirectSignIn: window.location.protocol + '//' + window.location.host + '/',
      redirectSignOut: window.location.protocol + '//' + window.location.host + '/',
      responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
    federationTarget: 'COGNITO_USER_POOLS'
  }
};
